import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { clearAuthSession, readAuthToken, safeReturnUrl } from './auth-session';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (readAuthToken()) return true;
    clearAuthSession();
    return this.router.createUrlTree(['/login'], { queryParams: {
      reason: 'expired', returnUrl: safeReturnUrl(state.url) || '/Sync'
    }});
  }
}
